import { useState } from 'react'
import { StopIcon } from 'shared/icons'
import {
  Button, Stack, StackProps
} from '@mui/material'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'

import { SearchResult, SearchStatus, useEditSearchStatus } from 'interface/search'

import { useUserSession } from 'features/session/context'

import { ConfirmDialog } from 'components/dialog/confirm'
import { Loading } from 'components/controls/loading'
import { ErrorBlock } from 'components/controls/errorInfo'

import { SearchsDiseaseListBlock } from './disease'
import { SearchsGuideLineListBlock } from './guideline'
import { SearchsConventionListBlock } from './convention'
import { SearchsDrugListBlock } from './drug'
import { SearchsSenmoniListBlock } from './senmoni'

import { StartAnalyticsDialog } from 'features/search/dialog/startAnalyticsDialog'

type SearchConditionPageProps = {
  search: SearchResult
  openGuideLine: (guideLineId: number) => void
  openConvention: (conventionId: number) => void
	onChangeSearch: (result: SearchResult) => void,
} & StackProps
export const SearchConditionPage = ({
  search,
  openGuideLine,
  openConvention,
	onChangeSearch,
  ...others
}: SearchConditionPageProps) => {
  const { isService, isGeneral } = useUserSession()
	const [modal, setModal] = useState<'reStartAnalytics' | 'startAnalytics' | 'stopAnalytics' | null>(null)

	const [postState, submit] = useEditSearchStatus(search.searchId, { onEditted: onChangeSearch })

  return (
    <Stack direction="column" padding={1} spacing={2} overflow="auto" boxSizing="border-box" {...others}>
			{postState.posting && <Loading/>}

      <SearchsDiseaseListBlock edittable={isGeneral} searchId={search.searchId}/>
      <SearchsDrugListBlock edittable={isGeneral} searchId={search.searchId}/>
      <SearchsSenmoniListBlock edittable={isGeneral} searchId={search.searchId}/>
      <SearchsGuideLineListBlock edittable={isGeneral} searchId={search.searchId} openGuideLine={openGuideLine}/>
      <SearchsConventionListBlock edittable={isGeneral} searchId={search.searchId} openConvention={openConvention}/>

      <Stack direction="column" position="relative" spacing={1}>
        <Stack direction="row" spacing={1}>
          {(search.status === SearchStatus.InProgress || search.status === SearchStatus.Progress) ? (
            <Button
              variant="outlined"
              size="large"
              color="warning"
              onClick={() => setModal("stopAnalytics")}
              disabled={!isService}
              startIcon={<StopIcon/>}
            >
              中止
            </Button>
          ) : (
            <Button
              variant="outlined"
              size="large"
              onClick={() => setModal("startAnalytics")}
              disabled={!isService}
              endIcon={<ArrowRightIcon/>}
            >
              {search.status === SearchStatus.Stop ? "分析開始" : "再分析"}
            </Button>
          )}
        </Stack>

        {postState.error && <ErrorBlock error={postState.error}/>}

      </Stack>

      {modal === 'startAnalytics' ? (
        <StartAnalyticsDialog
          search={search}
          onSubmit={(result) => {
            setModal(null)
            onChangeSearch(result)
          }}
          onClose={() => {
            setModal(null)
          }}
        />
      ) : modal === "stopAnalytics" ? (
				<ConfirmDialog
					message={`分析を中断します。よろしいですか？`}
          ok={{
            label: 'はい',
            onClick: () => {
              setModal(null)
              submit({ status: SearchStatus.Stop })
            }
          }}
          cancel={{
            label: 'いいえ',
            onClick: () => {
              setModal(null)
            }
          }}
				/>
			) : (
				<></>
			)}
    </Stack>
  )
}
